const $ = window.jQuery;

Ok.IncognitoAdmin = {
	sookies: [
		"incognito_masthead_views",
		"incognito_masthead_lastview",
		"incognito_masthead_viewing_window",
		"incognito_masthead_closed",
	],

	resetOnboarding() {
		window.history.replaceState(null, null, window.location.href);
		userGuides.ungraduate("INCOGNITO_TOGGLER,INCOGNITO_UPSELL", () => {
			window.location = window.location.href.replace(
				window.location.hash,
				"",
			);
		});
	},

	resetSookies() {
		const url = "/sookie/remote_sookie";

		// gtfo when we're dunzo
		if (!this.sookies.length) {
			window.location.reload();
			return;
		}

		// otherwise update that shit
		const sookie = this.sookies.pop();
		$.get(url, { name: sookie, delete: 1, rand: Math.random() }, () => {
			this.resetSookies();
		});
	},
};



// WEBPACK FOOTER //
// ./src/legacy/incognito/admin.js